import { ControlSizesXL, ControlSizesMD, ControlSizesSM, ControlSizesLG } from '../../../helpers/controlSizes/controlSizes/index.js';
import { BadgeSizeMD, BadgeSizeSM } from '../../../atoms/Badge/sizes/index.js';

const ChipSizeXL = {
    ...ControlSizesXL,
    badgeSize: BadgeSizeMD,
    borderWidth: 1,
    endButtonSize: 48,
    endIconSize: 24,
};
const ChipSizeLG = {
    ...ControlSizesLG,
    badgeSize: BadgeSizeMD,
    borderWidth: 1,
    endButtonSize: 44,
    endIconSize: 24,
};
const ChipSizeMD = {
    ...ControlSizesMD,
    badgeSize: BadgeSizeSM,
    borderWidth: 1,
    endButtonSize: 40,
    endIconSize: 24,
};
const ChipSizeSM = {
    ...ControlSizesSM,
    badgeSize: BadgeSizeSM,
    borderWidth: 1,
    endButtonSize: 32,
    endIconSize: 24,
};

export { ChipSizeLG, ChipSizeMD, ChipSizeSM, ChipSizeXL };
